export const maskEmail = (email: string, chars: number) => {
  const res = `${email.slice(0, chars)}****@${email.split('@')[1]}`;
  return res;
};
